import head from 'lodash/head'
import isArray from 'lodash/isArray'
import last from 'lodash/last'
import get from 'lodash/get'

export default {
  computed: {
    sectionColor() {
      if (get(this, 'sections')) {
        const section = last(head(this.sections))
        return get(section, 'color_info.hex', '')
      }
      return ''
    },
    firstSectionLineage() {
      let firstLineage = []
      if (get(this, 'sections') && isArray(this.sections)) {
        firstLineage = head(this.sections)
      }
      return firstLineage
    },
    firstSection() {
      let section = {}
      if (isArray(this.firstSectionLineage)) {
        section = head(this.firstSectionLineage)
      }
      return section
    },
    lastSection() {
      let section = {}
      if (isArray(this.firstSectionLineage)) {
        section = last(this.firstSectionLineage)
      }
      return section
    },
  },
  methods: {
    getLastSection(sections) {
      if (sections && isArray(sections)) {
        return last(head(sections))
      }
      return false
    },
  },
}



// WEBPACK FOOTER //
// ./components/mixins/section.js